import { mdiDelete, mdiDeleteRestore } from '@mdi/js';
import Icon from '@mdi/react';
import { useDocument } from '@nandorojo/swr-firestore';
import { serverTimestamp } from 'firebase/firestore';
import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
import { useMemo } from 'react';
import { useAuth } from '../../providers/AuthProvider';
import ErrorMessage from '../General/ErrorMessage';
import PageLoading from '../General/PageLoading';
import PostForm from './PostForm';

const PostEdit = () => {
  const { isLoggedIn } = useAuth();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const { slug } = router.query;

  const postId = useMemo(() => {
    const slugparts = [...slug];
    if (slug[0] === 'app') {
      slugparts.shift();
    }
    if (slugparts.length === 3 && slugparts[2] === 'edit') {
      // eslint-disable-next-line no-unused-vars
      const [, postID] = slugparts;
      const postslugparts = postID.split('-');
      return postslugparts[postslugparts.length - 1];
    }
  }, [slug]);

  const {
    data: post,
    error,
    update,
  } = useDocument(postId ? `posts/${postId}` : null, {
    listen: true,
  });

  const handleDelete = () => {
    const deletedAtTimestamp = serverTimestamp();
    const postData = {
      isDeleted: true,
      deleted: deletedAtTimestamp,
      modified: deletedAtTimestamp,
    };
    update({ postData });
    enqueueSnackbar('Your post was deleted.', { variant: 'success' });
    router.push('/home');
  };

  const handleUndelete = () => {
    const modifiedAtTimestamp = serverTimestamp();
    const postData = {
      isDeleted: false,
      deleted: null,
      modified: modifiedAtTimestamp,
    };
    update({ postData });
    enqueueSnackbar('Your post was restored.', { variant: 'success' });
  };

  if (!isLoggedIn) {
    return null;
  }

  if (error) {
    return <ErrorMessage error={error} />;
  }

  if (!post) {
    return <PageLoading />;
  }

  return (
    <div className="container is-narrow post-edit">
      <PostForm post={post} />
      <div className="buttons mt-6">
        {post.isDeleted ? (
          <button
            type="button"
            onClick={handleUndelete}
            className="button is-danger"
          >
            <span className="icon">
              <Icon path={mdiDeleteRestore} size={1} />
            </span>
            <span>Restore post</span>
          </button>
        ) : (
          <button
            type="button"
            onClick={handleDelete}
            className="button is-danger"
          >
            <span className="icon">
              <Icon path={mdiDelete} size={1} />
            </span>
            <span>Delete post</span>
          </button>
        )}
      </div>
    </div>
  );
};
export default PostEdit;
